import { useState } from 'react';
import { useBooking } from '../context/BookingContext';
import { api } from '../services/api';
import BookingDetailsModal from '../components/BookingDetailsModal';

const OwnerDashboard = () => {
  const { bookings, confirmBooking, cancelBooking, refreshBookings } = useBooking();
  const [selectedBooking, setSelectedBooking] = useState<any>(null);
  const [modalOpen, setModalOpen] = useState(false);

  const pending = bookings.filter(b => b.status === 'pending');
  const confirmed = bookings.filter(b => b.status === 'confirmed');

  const handleSaveNotes = async (id: number, notes: string) => {
    await api.updateBookingNotes(id, notes);
    await refreshBookings();
  };

  const openBookingDetails = (booking: any) => {
    setSelectedBooking(booking);
    setModalOpen(true);
  };

  return (
    <div className="max-w-6xl mx-auto p-4">
      <h2 className="text-2xl font-bold text-green-800 mb-6">Owner Dashboard</h2>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Pending bookings */}
        <div className="bg-white p-4 rounded-lg shadow">
          <h3 className="text-lg font-semibold mb-2 text-yellow-600">⏳ Pending Requests ({pending.length})</h3>
          {pending.length === 0 ? (
            <p className="text-gray-500">No pending bookings.</p>
          ) : (
            <ul className="divide-y divide-gray-200 max-h-96 overflow-y-auto">
              {pending.map((b) => (
                <li key={b.id} className="py-3">
                  <div className="flex flex-col gap-2">
                    <div className="flex justify-between items-start">
                      <div>
                        <p className="font-medium">Court {b.courtId}</p>
                        <p className="text-sm text-gray-600">{b.date} {b.startTime} - {b.endTime}</p>
                        <p className="text-sm text-gray-500">User: {b.userName}</p>
                        {b.firstName && b.lastName && (
                          <p className="text-sm text-gray-500">{b.firstName} {b.lastName}</p>
                        )}
                      </div>
                      <div className="flex gap-2 flex-shrink-0">
                        <button
                          onClick={() => confirmBooking(b.id)}
                          className="px-3 py-1 bg-green-600 text-white rounded hover:bg-green-700 text-sm"
                        >
                          Confirm
                        </button>
                        <button
                          onClick={() => cancelBooking(b.id)}
                          className="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700 text-sm"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={() => openBookingDetails(b)}
                          className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm"
                        >
                          View
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Confirmed bookings */}
        <div className="bg-white p-4 rounded-lg shadow">
          <h3 className="text-lg font-semibold mb-2 text-green-600">✅ Confirmed Bookings ({confirmed.length})</h3>
          {confirmed.length === 0 ? (
            <p className="text-gray-500">No confirmed bookings.</p>
          ) : (
            <ul className="divide-y divide-gray-200 max-h-96 overflow-y-auto">
              {confirmed.map((b) => (
                <li key={b.id} className="py-3">
                  <div className="flex flex-col gap-2">
                    <div className="flex justify-between items-start">
                      <div>
                        <p className="font-medium">Court {b.courtId}</p>
                        <p className="text-sm text-gray-600">{b.date} {b.startTime} - {b.endTime}</p>
                        <p className="text-sm text-gray-500">User: {b.userName}</p>
                        {b.firstName && b.lastName && (
                          <p className="text-sm text-gray-500">{b.firstName} {b.lastName}</p>
                        )}
                      </div>
                      <div className="flex gap-2">
                        <button
                          onClick={() => cancelBooking(b.id)}
                          className="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700 text-sm"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={() => openBookingDetails(b)}
                          className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm"
                        >
                          View
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {/* Booking Details Modal */}
      <BookingDetailsModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        booking={selectedBooking}
        onSaveNotes={handleSaveNotes}
      />
    </div>
  );
};

export default OwnerDashboard;